import { validatePhoneNumber } from '../../util/isValidPhone'

export const getClinicianPiiConfig = () => {
  return clinicianPiiConfig
}

const clinicianPiiConfig = [
  {
    id: 'name',
    type: 'TEXT',
    placeholder: 'Add clinician name',
    label: 'Name',
    prefix: '',
    postfix: '*',
    value: '',
    validation: { required: true },
    errorMsg: 'Name is required',
  },
  {
    id: 'phone',
    type: 'PHONE',
    placeholder: 'Add clinician phone number',
    label: 'Phone number',
    prefix: '',
    postfix: '*',
    value: '',
    validation: {
      validate: (value) => {
        return validatePhoneNumber(value)
      },
    },
    errorMsg: 'Phone number required',
    disabled: false,
  },
  {
    id: 'email',
    type: 'TEXT',
    placeholder: 'Add clinician email',
    label: 'Email',
    prefix: '',
    postfix: '*',
    value: '',
    validation: { required: true },
    errorMsg: 'Email required',
    disabled: false,
  },
  {
    id: 'jobTitle',
    type: 'TEXT',
    placeholder: 'Add a jobtitle',
    label: 'Job title:',
    prefix: '',
    postfix: '',
    value: '',
    validation: { required: false },
    disabled: false,
  },
]
